import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';
import Tag from '@wconcept/wconcept-ui-renewal/components/atoms/Tag';

interface IProps {
  prsnlType?:
    | 'MY_BRAND_TAG_HEART'
    | 'MY_BRAND_TAG_ORDER'
    | 'MY_BRAND_TAG_CLICK'
    | string
    | null;
  liveType?: 'onair' | 'ready' | 'ended' | string;
}

export const PrsnlTag = styled(Tag)<IProps>`
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.3);
  font-size: 12px;
  line-height: 130%;
  color: #fff;
  height: 24px;
  padding: 0 10px;
  ${mixin.flex({ justify: 'flex-start' })};

  > span {
    ${mixin.flex({ justify: 'flex-start' })};
    position: relative;

    & + span {
      padding-left: 6px;
      margin-left: 6px;

      &::after {
        content: '';
        display: inline-block;
        width: 1px;
        height: 10px;
        background-color: #fff;
        opacity: 0.4;
        position: absolute;
        left: 0;
      }
    }
  }

  .icon {
    ${mixin.flex({ display: 'inline-flex' })};
    width: 16px;
    height: 16px;
    margin-right: 2px;
    transform: translateY(1px);
  }

  .point {
    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 100%;
      background-color: #fff;
      margin-right: 5px;
    }

    &.onair::before {
      background-color: #ff4600;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20')};
    font-size: ${mixin.pxToVw('12')};
    height: ${mixin.pxToVw('24')};
    padding: ${mixin.pxToVw('0 10')};

    > span {
      & + span {
        padding-left: ${mixin.pxToVw('6')};
        margin-left: ${mixin.pxToVw('6')};

        &::after {
          height: ${mixin.pxToVw('10')};
        }
      }
    }

    .icon {
      width: ${mixin.pxToVw('16')};
      height: ${mixin.pxToVw('16')};
      margin-right: ${mixin.pxToVw('2')};
    }

    .point {
      &::before {
        width: ${mixin.pxToVw('4')};
        height: ${mixin.pxToVw('4')};
        margin-right: ${mixin.pxToVw('5')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 14px;
    height: 28px;
    padding: 0 11px;

    > span {
      & + span {
        padding-left: 7px;
        margin-left: 7px;

        &::after {
          height: 12px;
        }
      }
    }
  }
`;
